import type {
  PoolDataTransferObject,
  RaceKey,
  RacePageDataTransferObject,
} from '@mobi/api-types/racePage/types'
import ObservablePage from '../Model/Observables/ObservablePage'
import ObservablePool from '../Model/Observables/ObservablePool'
import ObservableRaceKey from '../Model/Observables/ObservableRaceKey'

export default {
  map(dto: RacePageDataTransferObject, model: ObservablePage) {
    for (const pool of dto.AvailablePools) {
      const poolTotal = this.createObservablePool(pool)
      model.addPoolTotal(poolTotal)
    }
  },

  mapAllUpPools(dto: RaceKey, model: ObservableRaceKey) {
    for (const pool of dto.AllUpPools) {
      const poolTotal = this.createObservablePool(pool)
      model.addAllUpPool(poolTotal)
    }
  },

  createObservablePool(poolDto: PoolDataTransferObject): ObservablePool {
    const poolTotal = new ObservablePool()
    poolTotal.hasJackpot(poolDto.HasJackpot)
    poolTotal.isAbandoned(poolDto.IsAbandoned)
    poolTotal.jackpotTotal(poolDto.JackpotTotal)
    poolTotal.name(poolDto.Name)
    poolTotal.total(poolDto.Total)
    poolTotal.poolingIcon(poolDto.PoolingIcon)
    poolTotal.jurisdictionDescription(poolDto.JurisdictionDescription)

    poolDto.RaceNumbers.forEach(raceNumber => {
      poolTotal.raceNumbers.push(raceNumber)
    })

    poolTotal.hasPoolingIcon(
      poolTotal.poolingIcon() != undefined && poolTotal.poolingIcon().length > 0
    )
    poolTotal.isInternationalPool(
      poolTotal.poolingIcon() != undefined && poolTotal.poolingIcon() === 'INT'
    )

    return poolTotal
  },
}
